<template>
    <div>
          <b-toast id="toast-register-check-postulant" variant="none" no-close-button toaster="b-toaster-top-center">
        <img src="@/assets/img/ico-check.png" style="margin-right: 10px; margin-top: -2px" />
        {{ messageRegisterTeacher }}
	    </b-toast>
        <b-toast id="toast-register-error-postulant" variant="none" no-close-button toaster="b-toaster-top-center">
        <img src="@/assets/img/ico-equis.png" style="margin-right: 10px; margin-top: -2px" />
        {{ messageRegisterTeacher }}
	    </b-toast>
        <b-breadcrumb>
            <b-breadcrumb-item @click="titleTeacher=true">{{$t('my-account.account-information')}}</b-breadcrumb-item>
            <b-breadcrumb-item style="display:none" active v-if="tabIndex==0">{{$t('my-account.account-information')}}</b-breadcrumb-item>
            <b-breadcrumb-item style="display:none" active v-if="tabIndex==1">{{$t('my-account.professional-information')}}</b-breadcrumb-item>
            <b-breadcrumb-item style="display:none" active v-if="tabIndex==2">{{$t('my-account.bank-information')}}</b-breadcrumb-item>
        </b-breadcrumb>
          <input type="tel" id="hiddeValues" v-show="false">
        <b-tabs class="sm" v-model="tabIndex">
            <b-tab lazy :title="$t('account-teacher.accountInformation')" active @click="tabIndex =0 ;changeActivityTab(0)">
                <div v-if="showLoadingFirst" class="container-loading">
                    <b-spinner :label="$t('reusables.loading')" ></b-spinner>
                </div>
        
                <div class="d-flex" style="position: relative;" v-else   >
                    
                    <div class="content-photo d-flex flex-column align-items-center mr-4" style="width: fit-content;">
                        <span style="position: relative;margin-bottom: 12px">
                            <b-avatar :src="urlPhoto ? urlPhoto : IMAGENES.PHOTO_TEACHER_DEFAULT" size="145px" 
                                  style="background:#B7B8BD;"></b-avatar>
                            <input type="file" ref="file" style="display: none" accept="image/*" @change="handleFile">
                            <div @click="$refs.file.click()" v-show="!accountStatus" class="camera">
                                <icon name="camera" />
                            </div>
                         
                                
                        </span>
                       
                      
                        <h6 class="bold">{{infoTeacher  ? infoTeacher.strFullName : ''}}</h6>
                        <div class="perfil-teacher" v-if="!flagPostulant">
                            <b-form-rating :value="totalQualification" no-border readonly></b-form-rating>
                            <b-link class="link blue" @click="getTeacherInformationAndComments">{{totalCommentary}} {{$t(totalCommentary==1 ? 'Review' : 'Reviews')}}</b-link>
                        </div>
                        <!--<div v-if="flagRejected" class="d-flex ">
                            <h4  style="margin-bottom: 0px;
                                    color: #d1263a;
                                    font-weight: 600;
                                    text-decoration: underline;">
                                Rejected
                            </h4>
                            <span class="ml-2 icon-info" v-b-tooltip.hover :title="$t('title.5')"><img class="svg" src="@/assets/icons/icon-info.svg"></span>
                        </div>-->
                     
                    </div>
                    <div class="w-100 pl-5" style="border-left:1px solid #b7b8bd;">
                        <div v-show="accountStatus">
                            <b-row class="account-data mb-3" style="margin-left:-15px;">
                                <b-col cols="4">
                                    <label>{{$t('my-account.name')}}</label>
                                    <span>{{ infoTeacher  ? infoTeacher.firstName : '' }}</span>
                                </b-col>
                                <b-col cols="4">
                                    <label>{{$t('my-account.last-name')}}</label>
                                    <span>{{ infoTeacher  ? infoTeacher.lastName : '' }}</span>
                                </b-col>
                            </b-row>
                            <b-row class="account-data mb-3" style="margin-left:-15px;">
                                <b-col cols="4">
                                    <label>{{$t('my-account.phone')}}</label>
                                    <div class="d-flex align-items-center">
                                        <div class="mr-2 iti__flag" :class="'iti__'+flajImg" /><span>{{infoTeacher ? `+${infoTeacher.extension_Phone} ${infoTeacher.phoneNumber}` : ''}}</span>
                                    </div>
                                </b-col>
                                <b-col cols="4">
                                    <label>{{$t('my-account.email')}}</label>
                                    <span>{{ infoTeacher  ? infoTeacher.email : '' }}</span>
                                </b-col>
                            </b-row>
                            <b-row class="account-data" style="margin-left:-15px;">
                                <b-col cols="4">
                                    <label >{{$t('my-account.birthdate')}}</label>
                                    
                                    <span>{{infoTeacher ? this.$moment(infoTeacher.birthDate).format('MM/DD/YYYY') : ''}}</span>
                                </b-col>
                                <!-- <b-col cols="4" class="d-flex align-items-center" v-if="flagApplyAgain"> -->
                                <b-col cols="4" class="d-flex align-items-center" v-if="flagApplyAgain && flagPostulant">
                                    <a href="/teacher/password/account" class="link blue"><span>{{$t('account-teacher.changePassword')}}</span></a>
                                </b-col>
                                 <b-col cols="4" class="d-flex align-items-center"  v-if="!flagPostulant">
                                    <a href="/teacher/password/account" class="link blue"><span>{{$t('account-teacher.changePassword')}}</span></a>
                                </b-col>
                            </b-row>
                            <!-- <b-button class="btn btn-primary">
                                Edit profile
                            </b-button> -->
                        </div>
                        <b-row class="account-data" v-show="!accountStatus">
                            <b-col cols="8">
                                <div class="d-flex">
                                
                                    <b-form-group id="input-firstname-title" style="margin-right:12px;max-width:180px;" :label="$t('reusables.Name')">
                                        <!-- <label >Nombre</label> -->
                                        <b-form-input id="input-firstname"  v-model="$v.formTeacher.firstName.$model"   
                                            v-bind:class="{ error: $v.formTeacher.firstName.$error}" >
                                        </b-form-input>
                                        <span class="error-input">{{ validationMsgRegistro($v.formTeacher.firstName)}}</span>
                                       
                                    </b-form-group>

                                    <b-form-group id="input-lastname-title" class="w-100" :label="$t('my-account.last-name')">
                                        <!-- <label >Last Names</label> -->
                                         
                                        <b-form-input id="input-lastname"  v-model="$v.formTeacher.lastName.$model"   
                                            v-bind:class="{ error: $v.formTeacher.lastName.$error}" >
                                        </b-form-input>
                                        <span class="error-input">{{ validationMsgRegistro($v.formTeacher.lastName)}}</span>
                                        
                                    </b-form-group>
                                </div>
                                <b-form-group id="input-email-title" :label="$t('my-account.email')">
                                    <!-- <label >Email</label> -->
                                  
                                        <b-form-input  id="input-email" type="email"  v-model="$v.formTeacher.email.$model"  
                                        v-bind:class="{ error: $v.formTeacher.email.$error}" >
                                    </b-form-input>
                                    <span class="error-input">{{ validationMsgRegistro($v.formTeacher.email)}}</span>
                                </b-form-group>
                                <div class="d-flex flex-column">
                                    <b-form-group :label="$t('my-account.phone')">
                                        <div class="d-flex">
                                            <b-form-input  type="tel" id="input-telefono" ref="inputTelefono" 
                                                v-model="$v.formTeacher.phoneNumber.$model" style="widht:120px;" class="w-100"
                                                required v-bind:class="{ error: $v.formTeacher.phoneNumber.$error}">
                                            </b-form-input>
                                            <b-form-input 
                                            type="tel" 
                                            id="input-telefono" 
                                             v-model="$v.formTeacher.phoneNumber.$model"
                                           
                                            :class="{ error: $v.formTeacher.phoneNumber.$error}" 
                                            ></b-form-input>
                                        </div>
                                        <span class="error-input">{{ validationMsgRegistro($v.formTeacher.phoneNumber)}}</span>
                                    </b-form-group>
                                        
                                    </div>
                                <!-- <b-form-group id="input-telefono-title" label="Telephone">
                                    <b-form-input  type="tel" id="input-telefono" ref="inputTelefono" placeholder="971 169 012" 
                                          v-model="$v.formTeacher.phoneNumber.$model" style="widht:120px;" class="w-100"
                                        required v-bind:class="{ error: $v.formTeacher.phoneNumber.$error}">
                                    </b-form-input>
                                    <span class="error-input">{{ validationMsgRegistro($v.formTeacher.phoneNumber)}}</span>
                                </b-form-group> -->
                                <b-form-group id="input-fecha-nacimiento-title" class="mb-0" :label="$t('my-account.birthdate')">
                                      <b-input-group class="datepicker-group">
                                       
                                        <b-form-input
                                            :class="{error:$v.formTeacher.strBirthDate.$error }"
                                          
                                            :value ="
                                            `${$v.formTeacher.strBirthDate.$model.split('-')[1]}/${$v.formTeacher.strBirthDate.$model.split('-')[2]}/${$v.formTeacher.strBirthDate.$model.split('-')[0]}`"
                                        ></b-form-input>
                                        <!--   :value ="$v.formTeacher.strBirthDate.$model.split('-')[0].reverse().join('/')" -->
                                        <b-input-group-append>
                                          
                                            <b-form-datepicker
                                            v-model ="$v.formTeacher.strBirthDate.$model"
                                            button-only
                                            right
                                            :max="max"
                                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                            locale="en"
                                            ></b-form-datepicker>

                                           
                                        </b-input-group-append>
                                          
                                    </b-input-group>
                                    <span class="error-input d-block">{{ validationMsgRegistro($v.formTeacher.strBirthDate)}}</span>
                                
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <!--v-if="flagApplyAgain"-->
                <div class="d-flex align-items-center" :class="[flagPostulant ?  'justify-content-between' :'justify-content-end', accountStatus ? 'mt-0' : 'mt-3']">
                    <!-- <h6 class="bold">My profile</h6> -->
                    <!-- <div v-if="accountStatus"> -->
                    <div class="d-flex align-items-center" v-if="flagPostulant">
                        <div v-if="flagRejected == true">
                               <span class="text-danger" style="padding-left: 40px;">Rejected</span>
                            <span class="ml-2 icon-info" id="tooltip"><icon name="info" /></span>
                            <b-tooltip  target="tooltip"  placement="right">
                                {{$t('account-teacher.after-one-month-from-last application', {DATEPOSTULATION: strFlagRejected})}}
                            </b-tooltip>
                        </div>
                        <div  v-if="flagRejected == null" >
                            <span class="text-danger" >{{$t('account-teacher.WaitingResponse')}}</span>
                        </div>
                    </div>
                 
                    <!--

                         <div class="d-flex justify-content-between mb-3" >
                        
                               
                            <div v-if="accountStatus" class="contentButtonButtom">
                             <b-button class="btn btn btn-primary"  v-if="showButtonEdit" @click="toggleEditAccount(false)">
                                <img class="svg" src="@/assets/icons/icon-pencil.svg"/>
                                Edit profile
                                </b-button>
                            </div>
                        
                            <div class="d-flex" v-else>
                                <b-button class="btn btn btn-primary" :disabled="$v.formTeacher.$invalid"  @click="updateInforAccount"  :class="{ loading: isLoading }" >
                                    Save changues
                                </b-button>
                                <button type="button" class="btn btn-primary ml-4" @click="toggleEditAccount(true)">{{$t('reusables.cancel')}}</button>
                            </div>
                           
                        </div>

                    -->
                    <div v-if="flagApplyAgain">
                         <div  v-if="accountStatus" class="d-flex">
                        <!-- <b-button class="btn btn btn-primary"  v-if="showButtonEdit" @click="toggleEditAccount(false)"> -->
                            <b-button variant="outline-primary" class="mr-3"  v-if="!showButtonEdit" @click="showButtonEdit = true" style="font-size: 13px;">
                                {{$t('account-teacher.applyAgain')}}
                            </b-button>
                            <b-button class="btn btn btn-primary" v-else @click="toggleEditAccount(false)" style="font-size: 13px;"> 
                                <icon name="pencil" />
                                {{$t('account-teacher.editProfile')}}
                            </b-button>
                        </div>
                    
                        <div class="d-flex" v-else>
                            <span  class="btn btn-danger mr-3" @click="toggleEditAccount(true)">Cancel</span>
                            <button class="btn btn btn-primary" :disabled="$v.formTeacher.$invalid"  @click="updateInforAccount"  :class="{ loading: isLoading }" >
                                {{$t('account-teacher.saveChanges')}}
                            </button>
                        </div>
                    
                    </div>

                    <div v-if="!flagPostulant">
                        <div  v-if="accountStatus" class="d-flex">
                        <!-- <b-button class="btn btn btn-primary"  v-if="showButtonEdit" @click="toggleEditAccount(false)"> -->
                            <b-button class="btn btn btn-primary" @click="toggleEditAccount(false)" style="font-size: 13px;"> 
                                <icon name="pencil" />
                                {{$t('account-teacher.editProfile')}}
                            </b-button>
                        </div>
                    
                        <div class="d-flex" v-else>
                            <span  class="btn btn-danger mr-3" @click="toggleEditAccount(true)">Cancel</span>
                            <button class="btn btn btn-primary" :disabled="$v.formTeacher.$invalid"  @click="updateInforAccount"  :class="{ loading: isLoading }" >
                                {{$t('account-teacher.saveChanges')}}
                            </button>
                        </div>
                    
                    </div>
                   
                </div>
            </b-tab>
            <b-tab lazy :title="$t('account-teacher.professionalInformation')" @click="tabIndex =1 ;changeActivityTab(1)" class="tabProfessionalInfo">
                <div v-if="showLoadingFirst" class="container-loading">
                    <b-spinner :label="$t('reusables.loading')" ></b-spinner>
                </div>
                <div  v-else >
                <div class="d-flex justify-content-between" v-if="flagApplyAgain">
                    <h6 class="sub-title"><span>{{$t('account-teacher.professionalInformation')}}</span></h6>
                    <!--&& showButtonEdit-->
                    <!-- <b-button class="btn btn btn-primary" @click="professionalStatus = false" v-show="professionalStatus ">
                        <icon name="pencil" />
                        {{$t('reusables.edit')}}
                    </b-button>
                    <div v-show="!professionalStatus">
                        <b-button class="btn btn btn-primary" @click="updateDataProfessional"  :disabled="$v.infoTeacherProfessional.$invalid"  :class="{ loading: isLoading }" >
                        {{$t('account-teacher.saveChanges')}}
                        </b-button>
                         <button type="button" class="btn btn-primary ml-4"  @click="toggleEdit()">{{$t('reusables.cancel')}}</button>
                    </div> -->
                   
                </div>
                   <div class="d-flex justify-content-between" v-if="!flagPostulant">
                    <h6 style="display:none" class="sub-title"><span>{{$t('account-teacher.professionalInformation')}}</span></h6>
                    <!--&& showButtonEdit-->
                   
                </div>
                  <b-row class="account-data" >
                    <b-col cols="5">
                        <b-form-group class="mb-4" :label="$t('account-teacher.VideoPresentation')">
                            <!-- <label>Video Presentation</label> -->
                            <a :href="infoTeacherProfessional.urlVideo" target="_blank" class="link blue" style="width: fit-content;" v-show="professionalStatus">
                              <span>{{infoTeacherProfessional.urlVideo}}
                            </span></a>
                         
                                   <b-form-input type="text"  v-model="$v.infoTeacherProfessional.urlVideo.$model"
                                   v-show="!professionalStatus"
                                v-bind:class="{ error: $v.infoTeacherProfessional.urlVideo.$error}" 
                            ></b-form-input>
                               <span class="error-input d-block">{{ validationMsgRegistro($v.infoTeacherProfessional.urlVideo)}}</span>
                         
                         
                        </b-form-group>
                        <b-form-group class="mb-4" :label="$t('account-teacher.Methodology')">
                            <!-- <label>Methodology</label> -->
                            <p style="max-height: 205px;overflow-y: auto;" v-show="professionalStatus">
                                {{infoTeacherProfessional.methodology}}
                            </p>
                            
                            <b-form-textarea v-show="!professionalStatus"
                                style="font-size:13px;max-height: 205px;"
                                v-model="$v.infoTeacherProfessional.methodology.$model"
                                   v-bind:class="{ error: $v.infoTeacherProfessional.methodology.$error}" 
                                no-resize
                                rows="10" 
                                placeholder="Please use at least 40 words."
                            >
                            </b-form-textarea>
                             <span class="error-input d-block">{{ validationMsgRegistro($v.infoTeacherProfessional.methodology)}}</span>
                          
                       
                        </b-form-group>
                        <b-form-group class="mb-0" :label="$t('account-teacher.LanguagesSpoken')">
                            <!-- <label>Languages Spoken</label> -->
                            <p  v-show="professionalStatus">   {{infoTeacherProfessional.candidatesLanguageDescription}}</p>     
                            
                                  <b-form-input type="text" v-model="$v.infoTeacherProfessional.candidatesLanguageDescription.$model" v-show="!professionalStatus"
                                v-bind:class="{ error: $v.infoTeacherProfessional.candidatesLanguageDescription.$error}" 
                            ></b-form-input>
                             <span class="error-input d-block">{{ validationMsgRegistro($v.infoTeacherProfessional.candidatesLanguageDescription)}}</span>
                            
                          
                        </b-form-group>
                    </b-col>
                    <b-col cols="3" id="content-profesional-information">
                      
                        <b-form-group class="mb-4" :label="$t('account-teacher.specialities')">
                            <!-- <label>Specialities</label> -->
                      
                            <b-form-checkbox-group class="d-flex flex-column"
                             :disabled="professionalStatus"  v-model="$v.infoTeacherProfessional.listSubjects.$model"
                             :options="optionsSpecialities" v-bind:class="{ error: $v.infoTeacherProfessional.listSubjects.$error}" 
                             name="flavour-1a"
                            ></b-form-checkbox-group>
                              <span class="error-input d-block">{{ validationMsgRegistro($v.infoTeacherProfessional.listSubjects)}}</span>
                          


                           
                        </b-form-group>
                       
                        <b-form-group class="check-row mb-0" :label="$t('account-teacher.ageGroups')">
                            <!-- <label>Age Groups</label> -->
                          
                                          <b-form-checkbox-group
                               :disabled="professionalStatus"
                               
                            v-model="$v.infoTeacherProfessional.listSegmentIds.$model"
                             v-bind:class="{ error: $v.infoTeacherProfessional.listSegmentIds.$error}" 
                       
                            :options="optionsAge"
                            name="flavour-1b"
                            ></b-form-checkbox-group>
                              <span class="error-input d-block">{{ validationMsgRegistro($v.infoTeacherProfessional.listSegmentIds)}}</span>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group class="mb-4" :label="$t('account-teacher.CvRésumé')">
                            <!-- <label>CV / Résumé</label> -->
                            <div class="modifyFiles" >
                                <div class="content-text-course" v-if="infoTeacherProfessional.candidatesMaterialsCV" >
                                    <h6 class="text-course">
                                        <img src="@/assets/icons/icon-file.svg" class="svg">
                                      
                                        <a class="blue" style="cursor:pointer;" @click="donwload(infoTeacherProfessional.candidatesMaterialsCV.id, infoTeacherProfessional.candidatesMaterialsCV.nameFile)">{{infoTeacherProfessional.candidatesMaterialsCV.nameFile}}</a>
                                        <div class="deleted" v-show="!professionalStatus" @click="deleteCV()"><icon name="trash" /></div>
                                    </h6>
                                </div>
                              
                                <div v-show="!professionalStatus && numFileCV == 0">
                                    <div class="created" v-show="!flagAddCv"  @click="flagAddCv = true">
                                         <icon name="table-create-blue" />
                                    </div>
                                </div>
                               


                                 <VueFileAgent
                                        v-if="flagAddCv"
                                        ref="vueFileAgent"
                                        :multiple="true"
                                        :deletable="true"
                                        :meta="true"
                                        :accept="'.pdf'"
                                        :maxSize="'10MB'"
                                        :maxFiles="maxFilesCV"
                                        :helpText="'Arrastra y suelta aquí los archivos'"
                                        :theme="'list'"
                                        @select="filesSelectedCV($event)"
                                        @beforedelete="onBeforeDeleteCV($event)"
                                        @delete="fileDeletedCV($event)"
                                        v-model="fileCV"
                                    >
                                    <template v-slot:after-inner>
                                        <p style="line-height: 1.3;margin-bottom: 4px;" :class="fileRecordsForUploadCV.length >= 1 ? 'mt-3': ''">
                                            {{$t('reusables.DragDropFiles')}}
                                        </p>
                                        <b-button class="btn btn-primary">
                                            {{$t('reusables.Browse')}}
                                        </b-button>
                                    </template >
                                        <template v-slot:after-outer>
                                        <p class="footer-file-agent">
                                            {{ fileRecordsForUploadCV.length }} / 1
                                        </p>
                                    </template >
                                    </VueFileAgent>
                            </div>
                        </b-form-group>
                        <b-form-group class="mb-4" :label="$t('account-teacher.degrees')">
                            <!-- <label>Degrees</label> -->
                            <div class="modifyFiles">
                                <div class="content-text-course"  v-if="infoTeacherProfessional.listCandidatesMaterialsDegrees">
                                    <h6 class="text-course" v-for="(item,index) in infoTeacherProfessional.listCandidatesMaterialsDegrees" :key="index">
                                        <img src="@/assets/icons/icon-file.svg" class="svg">
                                        <a class="blue"  style="cursor:pointer;" 
            @click="donwload(item.id, item.nameFile)">{{item.nameFile}}</a>
                                        <div class="deleted" v-show="!professionalStatus" @click="deleteDegrees(item,index)"><icon name="trash" /></div>
                                    </h6>
                                </div>
                                <div  v-show="!professionalStatus && numFileDegrees != 5">
                                     <div class="created" v-show="!flagAddDegrees"  @click="flagAddDegrees = true">
                                         <icon name="table-create-blue" />
                                         </div>
                                </div>
                             
                                   <VueFileAgent
                                        v-if="flagAddDegrees"
                                        ref="vueFileAgent"
                                        :multiple="true"
                                        :deletable="true"
                                        :meta="true"
                                        :accept="'.pdf,.jpg,.png'"
                                        :maxSize="'10MB'"
                                        :maxFiles="5 - numFileDegrees"
                                        :helpText="'Arrastra y suelta aquí los archivos'"
                                        :theme="'list'"
                                        @select="filesSelectedDegrees($event)"
                                        @beforedelete="onBeforeDeleteDegrees($event)"
                                        @delete="fileDeletedDegrees($event)"
                                        v-model="fileDegrees"
                                    >
                                    <template v-slot:after-inner>
                                        <p style="line-height: 1.3;margin-bottom: 4px;" :class="fileRecordsForUploadDegrees.length >= 1 ? 'mt-3': ''">
                                            {{$t('reusables.DragDropFiles')}}
                                        </p>
                                        <b-button class="btn btn-primary">
                                            {{$t('reusables.Browse')}}
                                        </b-button>
                                    </template >
                                        <template v-slot:after-outer>
                                        <p class="footer-file-agent">
                                            {{ fileRecordsForUploadDegrees.length }} / 5
                                        </p>
                                    </template >
                                    </VueFileAgent>
                            </div>
                        </b-form-group>
                        <b-form-group :label="$t('account-teacher.certificates')">
                            <!-- <label>Certificates</label> -->
                            <div class="modifyFiles">
                                 <div class="content-text-course"  v-if="infoTeacherProfessional.listCandidatesMaterialsCertificates">
                                    <h6 class="text-course" v-for="(item,index) in infoTeacherProfessional.listCandidatesMaterialsCertificates" :key="index">
                                        <img src="@/assets/icons/icon-file.svg" class="svg">
                                        <a class="blue"  style="cursor:pointer;"  @click="donwload(item.id, item.nameFile)">{{item.nameFile}}</a>
                                        <div class="deleted" v-show="!professionalStatus" @click="deleteCerti(item,index)"><icon name="trash" /></div>
                                    </h6>
                                </div>
                                <div  v-show="!professionalStatus && numFileCerti != 5">
                                     <div class="created" v-show="!flagAddCerti"  @click="flagAddCerti = true">
                                         <icon name="table-create-blue" />
                                         </div>
                                </div>
                             
                                   <VueFileAgent
                                        v-if="flagAddCerti"
                                        ref="vueFileAgent"
                                        :multiple="true"
                                        :deletable="true"
                                        :meta="true"
                                        :accept="'.pdf,.jpg,.png'"
                                        :maxSize="'10MB'"
                                        :maxFiles="5-numFileCerti"
                                        :helpText="'Arrastra y suelta aquí los archivos'"
                                        :theme="'list'"
                                        @select="filesSelectedCerti($event)"
                                        @beforedelete="onBeforeDeleteCerti($event)"
                                        @delete="fileDeletedCerti($event)"
                                        v-model="fileCerti"
                                    >
                                    <template v-slot:after-inner>
                                        <p style="line-height: 1.3;margin-bottom: 4px;" :class="fileRecordsForUploadCerti.length >= 1 ? 'mt-3': ''">
                                            {{$t('reusables.DragDropFiles')}}
                                        </p>
                                        <b-button class="btn btn-primary">
                                            {{$t('reusables.Browse')}}
                                        </b-button>
                                    </template >
                                        <template v-slot:after-outer>
                                        <p class="footer-file-agent">
                                            {{ fileRecordsForUploadCerti.length }} / 5
                                        </p>
                                    </template >
                                    </VueFileAgent>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div class="d-flex justify-content-end">
                    <b-button class="btn btn btn-primary" @click="professionalStatus = false" v-show="professionalStatus ">
                        <icon name="pencil" />
                        {{$t('reusables.edit')}}
                    </b-button>
                    <div v-show="!professionalStatus">
                        <div  class="d-flex">
                            <button type="button" class="btn btn-danger mr-3"  @click="toggleEdit()">{{$t('reusables.cancel')}}</button>
                            <b-button class="btn btn btn-primary" @click="updateDataProfessional"  :disabled="$v.infoTeacherProfessional.$invalid || numFileCV == 0"  :class="{ loading: isLoading }" >
                                {{$t('account-teacher.saveChanges')}}
                            </b-button>
                        </div>
                    </div>
                </div>
                </div>
              
              
            </b-tab>
            <!--!flagAccepted es un postulante  , flagAccepted es un profesor-->
            <b-tab lazy :title="$t('account-teacher.bankInformation')" @click="tabIndex =2 ;changeActivityTab(2)" :disabled="!flagAccepted" >

                <div v-if="showLoadingFirst" class="container-loading">
                    <b-spinner :label="$t('reusables.loading')" ></b-spinner>
                </div>
                <div v-else class="pb-5" style="position:relative;">
                    <!-- <h6 class="sub-title"><span>Bank Information</span></h6> -->
                <div class="contentButtonButtom d-flex">
                    <b-button class="btn btn btn-primary" @click="bankStatus = false" v-show="bankStatus">
                        <icon name="pencil" />
                        {{$t('account-teacher.editAccounts')}}
                    </b-button>
                    <b-button class="btn btn-danger mr-3" @click="cancelBank" v-show="!bankStatus">
                        {{$t('reusables.Cancel')}}
                    </b-button>
                    <b-button class="btn btn btn-primary" :disabled="$v.formBank.$invalid" @click="updateBank" :class="{ loading: isLoading }" v-show="!bankStatus">
                        {{$t('account-teacher.saveChanges')}}
                    </b-button>
                </div>
                 <b-row class="account-data">
                    <b-col cols="7">
                        <div class="d-flex align-items-center mb-4">
                            <img src="@/assets/img/bank-card.png">
                            <h6 class="bold ml-3">Account</h6>
                        </div>
                        <div class="d-flex">
                            <b-form-group class="w-100" :label="$t('account-teacher.nameBeneficiary')">
                                <!-- <label>Name of Beneficiary</label> -->
                                <p v-if="bankStatus">{{formBank.nameBene ? formBank.nameBene : "-"}}</p>
                                <div v-if="!bankStatus" >
                                    <b-form-input  type="text" 
                                    
                                            v-model="$v.formBank.nameBene.$model"
                                        required v-bind:class="{ error: $v.formBank.nameBene.$error}">
                                    </b-form-input>
                                    <span class="error-input">{{ validationMsgRegistro($v.formBank.nameBene)}}</span>
                                </div>
                            </b-form-group>
                            <b-form-group id="input-lastname-title" class="w-100 mb-0" :label="$t('account-teacher.accountNumber')" v-if="bankStatus">
                                <!-- <label>Account Number</label> -->
                                <p v-if="bankStatus">{{formBank.accountNumber ? formBank.accountNumber : "-"}}</p>
                                  <div v-if="!bankStatus" >
                                    <b-form-input  type="text" 
                                   
                                            v-model="$v.formBank.accountNumber.$model"
                                        required v-bind:class="{ error: $v.formBank.accountNumber.$error}">
                                    </b-form-input>
                                    <span class="error-input">{{ validationMsgRegistro($v.formBank.accountNumber)}}</span>
                                </div>
                            </b-form-group>
                        </div>
                        <b-form-group class="w-100 mr-3" :label="$t('account-teacher.NameBank')" v-if="!bankStatus">
                                <!-- <label>Name of Bank</label> -->
                                <p v-if="bankStatus">{{formBank.nameBank ? formBank.nameBank : "-"}}</p>
                                <div v-if="!bankStatus" >
                                    <b-form-input  type="text" 
                                    
                                            v-model="$v.formBank.nameBank.$model"
                                        required v-bind:class="{ error: $v.formBank.nameBank.$error}">
                                    </b-form-input>
                                    <span class="error-input">{{ validationMsgRegistro($v.formBank.nameBank)}}</span>
                                </div>
                            </b-form-group>
                        <div class="d-flex">
                            <b-form-group id="input-lastname-title" class="w-100 mr-3 mb-0" :label="$t('account-teacher.accountNumber')" v-if="!bankStatus">
                                <!-- <label>Account Number</label> -->
                                <p v-if="bankStatus">{{formBank.accountNumber ? formBank.accountNumber : "-"}}</p>
                                  <div v-if="!bankStatus" >
                                    <b-form-input  type="text" 
                                   
                                            v-model="$v.formBank.accountNumber.$model"
                                        required v-bind:class="{ error: $v.formBank.accountNumber.$error}">
                                    </b-form-input>
                                    <span class="error-input">{{ validationMsgRegistro($v.formBank.accountNumber)}}</span>
                                </div>
                            </b-form-group>
                            <b-form-group class="w-100" :label="$t('account-teacher.NameBank')" v-if="bankStatus">
                                <!-- <label>Name of Bank</label> -->
                                <p v-if="bankStatus">{{formBank.nameBank ? formBank.nameBank : "-"}}</p>
                                <div v-if="!bankStatus" >
                                    <b-form-input  type="text" 
                                    
                                            v-model="$v.formBank.nameBank.$model"
                                        required v-bind:class="{ error: $v.formBank.nameBank.$error}">
                                    </b-form-input>
                                    <span class="error-input">{{ validationMsgRegistro($v.formBank.nameBank)}}</span>
                                </div>
                            </b-form-group>
                            <b-form-group class="w-100 mb-0" :label="$t('account-teacher.CCINumber')">
                                <!-- <label>CCI Number</label> -->
                                <p v-if="bankStatus">{{formBank.numberCii ? formBank.numberCii : "-"}}</p>
                                 <div v-if="!bankStatus" >
                                <b-form-input  type="text" 
                             
                                        v-model="$v.formBank.numberCii.$model"
                                    required v-bind:class="{ error: $v.formBank.numberCii.$error}">
                                </b-form-input>
                                <span class="error-input">{{ validationMsgRegistro($v.formBank.numberCii)}}</span>
                                </div>
                            </b-form-group>
                        </div>
                    </b-col>
                    <b-col>
                         <div class="d-flex align-items-center mb-4">
                            <img src="@/assets/img/bank-paypal.png">
                            <h6 class="bold ml-3">PayPal</h6>
                        </div>
                        <b-form-group class="w-100 mr-3" :label="$t('account-teacher.Email')">
                            <!-- <label>Name of Beneficiary</label> -->
                            <p v-if="bankStatus">{{formBank.nameBenePaypal ? formBank.nameBenePaypal : "-"}}</p>
                             <div v-if="!bankStatus" >
                                <b-form-input  type="text"                               
                                        v-model="$v.formBank.nameBenePaypal.$model"
                                    required v-bind:class="{ error: $v.formBank.nameBenePaypal.$error}">
                                </b-form-input>
                                <span class="error-input">{{ validationMsgRegistro($v.formBank.nameBenePaypal)}}</span>
                                </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                </div>
              
               
            </b-tab>
        </b-tabs>
        <!-- <div v-if="flagPostulant">
            <div class="mt-5" v-if="!flagApplyAgain">
                <b-alert show variant="danger">{{strApplyAgain}}</b-alert>
            </div>
            
        </div> -->
         <modalTeacher :teacherInformation="teacherInformation" :flagEdit="false"/>
    </div>
</template>
<script>
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import Vue from 'vue';
import {mapState} from "vuex";
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import modalTeacher from "@/components/modals/commentary";
import { required, email, numeric, minLength, maxLength } from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages';
import * as tools from '@/assets/js/tools.js';
import axios from 'axios';
import  cursosJsonEN  from '@/locales/material/cursos-en.json';
import  examenesJsonEN  from '@/locales/material/examenes-en.json';
import {IMAGENES} from '@/assets/js/appConstants'; 

import {countWords} from '@/assets/js/custom-validations.js';

Vue.use(VueFileAgent);
const formRegisterMessages = {

  required: function() {
    return this.$t('validations.formRegisterMessages.required-1')
  },
  email: function() {
    return this.$t('validations.formRegisterMessages.email')
  },
  flagEmailEnUso: function() {
    return this.$t('validations.formRegisterMessages.flagEmailEnUso')
  },
  minLength: function({
    $params
  }) {
    return this.$t('validations.formRegisterMessages.minLength', {
      nro: $params.minLength.min
    });
  },
  maxLength: function({
    $params
  }) {
    return this.$t('validations.formRegisterMessages.maxLength', {
      nro: $params.maxLength.max
    });
  },
  alphaWithSpaces: function() {
    return this.$t('validations.formRegisterMessages.alphaWithSpaces')
  },
  numeric: function() {
    return this.$t('validations.formRegisterMessages.numeric')
  },
  countWords: () => "Please use at least 40 words.",
  validateBankPaypal: () => "Ya has registrado información de una Cuenta Bancaria",
  validateBankAccount: () => "Ya has registrado información de Paypal",
  validateRequired: () => "Debes ingresar todos los campos de Cuenta Bancaria",
};



export default {
  components: {
    modalTeacher
  },

  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const maxDate = new Date(today)
    //console.log("maxDate: ",maxDate)
    return {
      lang: localStorage.getItem('lang') || 'es',
      totalQualification: 0,
      totalCommentary: 0,
      showLoadingFirst: false,
      showButtonEdit: false,
      showButtonStatus: false,
      listFilesDeleteIds: [],
      flagRejected: false,
      strFlagRejected: '',
      flagAddCerti: false,
      flagAddDegrees: false,
      flagAddCv: false,
      messageRegisterTeacher: '',
      flagPhoto: false,
      isLoading: false,
      flagAccepted: false,
      flagApplyAgain: false,
      max: maxDate,
      strApplyAgain: '',
      urlPhoto: null,
      photo: null,
      flagEdit: false,
      infoTeacher: null,
      formTeacher: null,
      formTeacherProfessional: null,
      selectedSpecialities: [],
      selectedAge: [],
      fileCV: [],
      fileDegrees: [],
      fileCerti: [],
      numFileCerti: 0,
      numFileDegrees: 0,
      numFileCV: 0,
      maxFilesCV: 1,
      infoTeacherProfessional: {
        urlVideo: null,
        candidatesLanguageDescription: null,
        methodology: null,
        candidatesMaterialsCV: null,
        listCandidatesMaterialsDegrees: [],
        listCandidatesMaterialsCertificates: [],
        listSegmentIds: [],
        listSubjects: [],
      },

      tabIndex: 0,
      bankStatus: true,
      accountStatus: true,
      professionalStatus: true,

      iti: null,
      listIntlCountries: [],
      optionsSpecialities: [],
      optionsAge: [],
      fileRecordsForUploadCV: [],
      fileRecordsForUploadDegrees: [],
      fileRecordsForUploadCerti: [],
      uploadUrl: 'https://www.mocky.io/v2/5d4fb20b3000005c111099e3',
      uploadHeaders: {
        'X-Test-Header': 'vue-file-agent'
      },
      flajImg: '',
      formBank: {
        id: 0,
        nameBene: "",
        nameBank: "",
        accountNumber: "",
        numberCii: "",
        nameBenePaypal: ""
      },
      teacherInformation: null,
      IMAGENES: IMAGENES,
    }
  },
  validations: {
    formTeacher: {
      firstName: {
        required
      },
      lastName: {
        required
        /*minLength: minLength(2),
        maxLength: maxLength(60),
        alphaWithSpaces(value) {
            return /^[A-zÀ-ú\s]*$/.test(value);
        }*/
      },
      email: {
        required,
        email,
        flagEmailEnUso(value) {
          if (value === '' || !this.$v.formTeacher.email) return true

          return new Promise((resolve, reject) => {
            return baseInstanceAxios.get(`${this.apiURL}/resources/PersonsStudents/ExistsEmailByStudents?Email=${value}&Id=${this.User.id}&FlagStudent=false`)
              .then(response => {
                resolve(!response.data.return);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      },
      phoneNumber: {
        required,
        numeric
      },
      strBirthDate: {
        required
      },
    },

    infoTeacherProfessional: {
      urlVideo: {
        required
      },
      candidatesLanguageDescription: {
        required
      },
      methodology: {
        required,
        countWords
      },
      listSegmentIds: {
        required
      },
      listSubjects: {
        required
      }
    },
    formBank: {
      nameBene: {
        //required
        validateBankAccount(value) {
          var fl = value && (this.$v.formBank.nameBenePaypal.$model) ? false : true;
          return fl;
        },
        validateRequired(value) {
          var fl = ((this.$v.formBank.nameBene.$model && this.$v.formBank.nameBank.$model && this.$v.formBank.accountNumber.$model && this.$v.formBank.numberCii.$model) && this.$v.formBank.nameBenePaypal.$model == "") ||
            this.$v.formBank.nameBene.$model == "" && this.$v.formBank.nameBank.$model == "" && this.$v.formBank.accountNumber.$model == "" && this.$v.formBank.numberCii.$model == "" ?
            true : false;
          return fl;
        },

      },
      nameBank: {
        //required
        validateBankAccount(value) {
          var fl = value && (this.$v.formBank.nameBenePaypal.$model) ? false : true;
          //console.log("validateBankAccount: " + fl)
          return fl;
        },
        validateRequired(value) {
          var fl = ((this.$v.formBank.nameBene.$model 
                  && this.$v.formBank.nameBank.$model 
                  && this.$v.formBank.accountNumber.$model 
                  && this.$v.formBank.numberCii.$model) 
                  && this.$v.formBank.nameBenePaypal.$model == "") ||
            this.$v.formBank.nameBene.$model == "" && this.$v.formBank.nameBank.$model == "" && this.$v.formBank.accountNumber.$model == "" && this.$v.formBank.numberCii.$model == "" ?
            true : false;
  

          /*console.log("formBank.nameBene: " + this.$v.formBank.nameBene.$model )
          console.log("formBank.nameBank: " + this.$v.formBank.nameBank.$model)
          console.log("formBank.accountNumber: " + this.$v.formBank.accountNumber.$model )
          console.log("formBank.numberCii: " + this.$v.formBank.numberCii.$model)
          console.log("formBank.nameBenePaypal: " + this.$v.formBank.nameBenePaypal.$model)
          console.log("====================")  */
          //console.log("validateRequired: " + fl)
          return fl;
        }
      },
      accountNumber: {
        //required
        validateBankAccount(value) {
          var fl = value && (this.$v.formBank.nameBenePaypal.$model) ? false : true;
          return fl;
        },
        validateRequired(value) {
          var fl = ((this.$v.formBank.nameBene.$model && this.$v.formBank.nameBank.$model && this.$v.formBank.accountNumber.$model && this.$v.formBank.numberCii.$model) && this.$v.formBank.nameBenePaypal.$model == "") ||
            this.$v.formBank.nameBene.$model == "" && this.$v.formBank.nameBank.$model == "" && this.$v.formBank.accountNumber.$model == "" && this.$v.formBank.numberCii.$model == "" ?
            true : false;
          return fl;
        }
      },
      numberCii: {
        //required
        validateBankAccount(value) {
          var fl = value && (this.$v.formBank.nameBenePaypal.$model) ? false : true;
          return fl;
        },
        validateRequired(value) {
          var fl = ((this.$v.formBank.nameBene.$model && this.$v.formBank.nameBank.$model && this.$v.formBank.accountNumber.$model && this.$v.formBank.numberCii.$model) && this.$v.formBank.nameBenePaypal.$model == "") ||
            this.$v.formBank.nameBene.$model == "" && this.$v.formBank.nameBank.$model == "" && this.$v.formBank.accountNumber.$model == "" && this.$v.formBank.numberCii.$model == "" ?
            true : false;
          return fl;
        }
      },
      nameBenePaypal: {
        email,
        validateBankPaypal(value) {
           
          var fl = (value != "" && (this.$v.formBank.nameBene.$model == "" || this.$v.formBank.nameBank.$model == "" || this.$v.formBank.accountNumber.$model == "" || this.$v.formBank.numberCii.$model == "")) ||
            (value == "" && (!this.$v.formBank.nameBene.$error && !this.$v.formBank.nameBank.$error && !this.$v.formBank.accountNumber.$error && !this.$v.formBank.numberCii.$error  )) ?
            true : false;
          //console.log("validateBankInfo: " +fl )
          return fl;
        }
      }
    },
    validationGroup: ['formTeacher', 'infoTeacherProfessional', 'formBank']
  },
  watch:{
    tabIndex: function (val){
      this.accountStatus = true;
      this.professionalStatus = true;
      this.bankStatus = true;
    },
  },
  created() {

    //console.log("this.flagPostulant: ",this.flagPostulant)
    if (this.flagPostulant) {
      this.showButtonEdit = false;
    }


    this.changeActivityTab(0)
    this.getListSubjectAndSegment();

  },
  mounted() {
    this.getListIntlCountries();

  },
  computed: {
    ...mapState(['flagPostulant']),
    User: {
      get() {
        return this.$store.state.user;
      },
      set(value) {
        this.$store.commit('mutateUser', value);
      }
    }
  },
  updated() {
    this.$nextTick(function() {
      tools.imgToSvg()
    })
  },
  methods: {
    donwload(idFile, fileName) {
      let headers = {
        responseType: "blob"
      };

      baseInstanceAxios
        .get(`${this.apiURL}/Resources/PersonsTeachers/DownloadFileTeacher?idFile=${idFile}`, headers)
        .then((response) => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(new Blob([response.data]));
          link.setAttribute('download', `${fileName}`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).catch(() => {});
    },
    getTeacherInformationAndComments() {

      baseInstanceAxios
        .get(`${this.apiURL}/resources/PersonsTeachers/GeTeacherInformationAndCommentList?PersonTeacherId=${this.$store.state.user.personTeacherId}&flagLanguage=${false}`)
        .then(response => {
          if (response.data != null && response.data.entity != null) {

            this.teacherInformation = response.data.entity;
            this.$bvModal.show('modal-commentary-teacher');
          }
        });
    },

    getListIntlCountries() { //Temporal => GH
      let input = document.getElementById('hiddeValues');

      let itil = intlTelInput(input);

      this.listIntlCountries = itil.countries;

      itil.destroy();
      input.remove();
    },
    toggleEditAccount(flag) {
      this.accountStatus = flag;
      this.flagPhoto = false;
      if (flag) {
        this.urlPhoto = this.infoTeacher.photo;
        this.iti.destroy();
        this.getInfoTeacher();
      } else {

        let country = this.listIntlCountries.find(x => x.dialCode == this.infoTeacher.extension_Phone);

        const input = document.querySelector("#input-telefono");

        this.iti = intlTelInput(input, {
          initialCountry: country ? country.iso2 : "pe",
          preferredCountries: ['US', 'PE'],
          separateDialCode: true
        });



      }




    },
    handleFile(event) {
      this.photo = null;
      for (var i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        this.urlPhoto = URL.createObjectURL(file);
        this.photo = file;
        break;
      }
      this.flagPhoto = true;
    },
    getFormatData(data) {

      let strBirthDate = data.strBirthDate.split('-').reverse().join('-');
      let newData = {
        id: data.id,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        extension_Phone: data.extension_Phone,
        phoneNumber: data.phoneNumber,
        strBirthDate: strBirthDate,
        photo: data.photo,
      };


      return newData;
    },
    getInfoTeacher() {
      this.showLoadingFirst = true;
      baseInstanceAxios
        .get(`${this.apiURL}/resources/PersonsTeachers/GetByPersonTeacherAccount`, {
          params: {
            personId: this.User.id
          }
        })
        .then(response => {

          if (response.data != null && response.data.entity) {

            //FlagApplyAgain: falso no puede postular hasta que pase el tiempo establecido según la documentación
            /* 
            FlagAccepted: si es true ya no es un postulante
            sí es postulante considerar los campos {
            FlagApplyAgain: falso no puede postular hasta que pase el tiempo establecido según la documentación

            StrApplyAgain:Muestra el mensaje según la documentación

            }
            */

            this.flagApplyAgain = response.data.entity.flagApplyAgain;
            this.strApplyAgain = response.data.entity.strApplyAgain;
            this.flagAccepted = response.data.entity.flagAccepted
            this.infoTeacher = response.data.entity.person

            this.flagRejected = response.data.entity.flagRejected;
            this.strFlagRejected = response.data.entity.strFlagRejected;

            if (this.infoTeacher.photo) {
              this.urlPhoto = this.infoTeacher.photo;
            } else {
              this.infoTeacher.photo = this.urlPhoto;
            }
            this.totalQualification = response.data.entity.totalQualification,
              this.totalCommentary = response.data.entity.totalCommentary,
              this.formTeacher = this.getFormatData(response.data.entity.person);
            this.showLoadingFirst = false;

            let country = this.listIntlCountries.find(x => x.dialCode == this.infoTeacher.extension_Phone);
            this.flajImg = country.iso2
          }
        });
    },
    cancelBank() {
      this.bankStatus = true;
      this.$v.formBank.$reset()
      this.getInfoBank();
    },
    updateBank() {

      this.isLoading = true;

      let json = {
        Id: this.formBank.id,
        PersonTeacherId: this.User.personTeacherId,
        NameBeneficiary: this.formBank.nameBene,
        NameBank: this.formBank.nameBank,
        AccountNumber: this.formBank.accountNumber,
        AccountCCINumber: this.formBank.numberCii,
        EmailPaypal: this.formBank.nameBenePaypal,
        UserCreated: this.$store.state.user.email,
      }

      baseInstanceAxios
        .post(`${this.apiURL}/resources/PersonsTeachers/SaveUpdateByTeachersAccountSalary`, json)
        .then((response) => {

          this.messageRegisterTeacher = "Your bank information was updated."
          this.$bvToast.show("toast-register-check-postulant");
          this.isLoading = false;
          this.cancelBank();

        }).catch(function(error) {

          this.messageRegisterTeacher = this.$t('register.text');
          this.$bvToast.show("toast-register-error");
          this.isLoading = false;
        });


    },

    updateDataProfessional() {
      this.isLoading = true;
      let listSegmentIds = this.infoTeacherProfessional.listSegmentIds;
      let listSubject = [];
      listSubject = this.infoTeacherProfessional.listSubjects.map(element => ({
        SubjectProgramId: parseInt(element.split('-')[0]),
        FlagProgram: element.split('-')[1] == "true" ? true : false
      }))
      const model = Object.freeze({
        "Id": this.User.id,
        "Methodology": this.infoTeacherProfessional.methodology,
        "CandidatesLanguageDescription": this.infoTeacherProfessional.candidatesLanguageDescription,
        "ListSegmentIds": listSegmentIds,
        "ListSubjectLevelIds": listSubject,
        "UrlVideo": this.infoTeacherProfessional.urlVideo,
        "FlagLoginAdmin": this.$store.state.is_admin,
        "UserCreated": this.$store.state.is_admin ? this.$store.state.user.emailAdmin : this.$store.state.user.email, //TODO:validar
      });



      const formData = new FormData();
      formData.append("FileCV", this.fileCV.length > 0 ? this.fileCV[0].file : null);
      this.listFilesDeleteIds.forEach(element => {
        formData.append("ListFilesDeleteIds", element);
      });


      this.fileDegrees.forEach(element => {

        formData.append("ListFilesDegrees", element.file)
      });

      this.fileCerti.forEach(element => {

        formData.append("ListFilesCertificates", element.file)
      });

      formData.append("ModelStr", JSON.stringify(model));


      axios({
          method: "POST",
          url: `${this.apiURL}/resources/PersonsTeachers/UpdateByTeachersByCandidateProfessional`,
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': 'Bearer ' + this.$store.state.authToken
          }
        })
        .then(response => {

          if (response.data != null && response.data.return) {
            this.messageRegisterTeacher = this.$t('mjesRegistro.registry-updated-successfully')
            this.$bvToast.show("toast-register-check-postulant");
            this.isLoading = false;
            this.toggleEdit();
          } else {
            this.messageRegisterTeacher = this.$t('mjesRegistro.mjeActualizacionError');
            this.$bvToast.show("toast-register-error-postulant");
            this.isLoading = false;
          }

        })
        .catch(function(error) {
          console.log(error);
          this.messageRegisterTeacher = this.$t('register.text');
          this.$bvToast.show("toast-register-error");
          this.isLoading = false;
        });


    },
    toggleEdit() {
      this.professionalStatus = true;
      this.flagAddCerti = false;
      this.flagAddDegrees = false;
      this.flagAddCv = false;
      
      this.fileRecordsForUploadCV = [];
      this.fileRecordsForUploadDegrees= [];
      this.fileRecordsForUploadCerti= [];
	    this.fileCV= [];
      this.fileDegrees= [];
      this.fileCerti= [];
  
      this.$v.$reset();
      this.getInfoProfessional();

    },
    deleteCerti(item, index) {

      this.fileRecordsForUploadCerti = this.fileRecordsForUploadCerti.filter(function(x) {
        if (x.id == item.id) {
          return false;
        }
        return true
      })
      this.listFilesDeleteIds.push(item.id);
      this.infoTeacherProfessional.listCandidatesMaterialsCertificates.splice(index, 1)
      this.numFileCerti = this.infoTeacherProfessional.listCandidatesMaterialsCertificates.length
      if(this.numFileCerti == 0){
        this.flagAddCerti = true;
      }
    },
    deleteDegrees(item, index) {
      this.fileRecordsForUploadDegrees = this.fileRecordsForUploadDegrees.filter(function(x) {
        if (x.id == item.id) {
          return false;
        }
        return true
      })
      this.listFilesDeleteIds.push(item.id);
      this.infoTeacherProfessional.listCandidatesMaterialsDegrees.splice(index, 1)

      this.numFileDegrees = this.infoTeacherProfessional.listCandidatesMaterialsDegrees.length;
      if(this.numFileDegrees == 0){
        this.flagAddDegrees = true;
      }
    },
    deleteCV() {

      this.listFilesDeleteIds.push(this.infoTeacherProfessional.candidatesMaterialsCV.id);
      this.infoTeacherProfessional.candidatesMaterialsCV = null;
      this.flagAddCv = true;
      this.numFileCV = 0;

    },
    changeActivityTab(typeTab) {

      if (typeTab == 0) {

        this.getInfoTeacher();
      }

      if (typeTab == 1) {
        this.getInfoProfessional();
      }

      if (typeTab == 2) {

        this.getInfoBank();
      }
    },
    getInfoBank() {
      this.showLoadingFirst = true;
      baseInstanceAxios
        .get(`${this.apiURL}/resources/PersonsTeachers/GetByPersonTeacherBank`, {
          params: {
            personId: this.User.id
          }
        })
        .then(response => {

          if (response.data != null && response.data.entity) {

            this.formBank.id = response.data.entity.id,
              this.formBank.nameBene = response.data.entity.nameBeneficiary,
              this.formBank.nameBank = response.data.entity.nameBank,
              this.formBank.accountNumber = response.data.entity.accountNumber,
              this.formBank.numberCii = response.data.entity.accountCCINumber,
              this.formBank.nameBenePaypal = response.data.entity.emailPaypal

          } else {

            this.bankStatus = false;
          }
          this.showLoadingFirst = false;
        });
    },
    getInfoProfessional() {
      this.showLoadingFirst = true;
      baseInstanceAxios
        .get(`${this.apiURL}/resources/PersonsTeachers/GetByPersonTeacherProfessional`, {
          params: {
            personId: this.User.id
          }
        })
        .then(response => {

          if (response.data != null && response.data.entity) {
            console.log("response.data.entity: ", response.data.entity)
            // this.infoTeacherProfessional = response.data.entity
            this.infoTeacherProfessional.urlVideo = response.data.entity.urlVideo
            this.infoTeacherProfessional.candidatesLanguageDescription = response.data.entity.candidate ? response.data.entity.candidate.candidatesLanguageDescription : null
            this.infoTeacherProfessional.methodology = response.data.entity.candidate ? response.data.entity.candidate.methodology : null
            this.infoTeacherProfessional.candidatesMaterialsCV = response.data.entity.candidate ? response.data.entity.candidate.candidatesMaterialsCV : null
            this.numFileCV = response.data.entity.candidate ? response.data.entity.candidate.candidatesMaterialsCV!=null? 1: 0 : 0;

            this.infoTeacherProfessional.listCandidatesMaterialsDegrees = response.data.entity.candidate ? response.data.entity.candidate.listCandidatesMaterialsDegrees : null
            this.fileRecordsForUploadDegrees = response.data.entity.candidate ? response.data.entity.candidate.listCandidatesMaterialsDegrees ? response.data.entity.candidate.listCandidatesMaterialsDegrees : [] : [];
            this.numFileDegrees = response.data.entity.candidate ? response.data.entity.candidate.listCandidatesMaterialsDegrees ? response.data.entity.candidate.listCandidatesMaterialsDegrees.length : 0 : 0;
            this.infoTeacherProfessional.listCandidatesMaterialsCertificates = response.data.entity.candidate ? response.data.entity.candidate.listCandidatesMaterialsCertificates : null
            this.fileRecordsForUploadCerti = response.data.entity.candidate ? response.data.entity.candidate.listCandidatesMaterialsCertificates ? response.data.entity.candidate.listCandidatesMaterialsCertificates : [] : [];
            this.numFileCerti = response.data.entity.candidate ? response.data.entity.candidate.listCandidatesMaterialsCertificates ? response.data.entity.candidate.listCandidatesMaterialsCertificates.length : 0 : 0;
            let arraySegments = []
            if (response.data.entity.listSegmentIds) {
              response.data.entity.listSegmentIds.forEach(element => {
                arraySegments.push(element)
              });
            }
            this.infoTeacherProfessional.listSegmentIds = arraySegments

            this.infoTeacherProfessional.listSubjects = response.data.entity.listSubjects ? response.data.entity.listSubjects.map(element => `${element.subjectProgramId}-${element.flagProgram}`) : []
          }




          this.showLoadingFirst = false;

        });
    },
    validationMsgRegistro: validationMessage(formRegisterMessages),

    getListSubjectAndSegment() {
      baseInstanceAxios
        .get(`${this.apiURL}/resources/Subjects/ListSubjectsLevelAndSegmentsTeacher`)
        .then(response => {

          this.optionsAge = response.data.entity.listSegments.map(element => ({
            text: element.descripcion,
            value: element.id
          }));
          this.optionsSpecialities = response.data.entity.listSubjects.map(element => ({
            //text : element.subjectProgramName,subjectProgramId
            text: element.flagProgram ?
              cursosJsonEN.cursos.find(el => el.id == element.subjectProgramId) != null ? cursosJsonEN.cursos.find(el => el.id == element.subjectProgramId).title : element.subjectProgramName : examenesJsonEN.cursos.find(el => el.title.toUpperCase() == element.subjectProgramName.toUpperCase()) != null ? examenesJsonEN.cursos.find(el => el.title.toUpperCase() == element.subjectProgramName.toUpperCase()).acronym : element.subjectProgramName,
            value: `${element.subjectProgramId}-${element.flagProgram}`
          }));


        });
    },

    updateInforAccount() {
      this.isLoading = true;
      console.log("this.formTeacher.strBirthDate : ", this.formTeacher.strBirthDate)
      let birthDate = this.$moment(this.formTeacher.strBirthDate)
      console.log("birthDate : ", birthDate)
      const model = Object.freeze({
        "Id": this.User.id,
        "FirstName": this.formTeacher.firstName,
        "LastName": this.formTeacher.lastName,
        "Email": this.formTeacher.email,
        "Extension_Phone": this.iti.selectedCountryData.dialCode,
        "PhoneNumber": this.formTeacher.phoneNumber,
        "BirthDate": birthDate,
        "FlagPhoto": this.flagPhoto,
        "UserModified": this.$store.state.is_admin ? this.$store.state.user.emailAdmin : this.formTeacher.email, //TODO:validar
        "FlagLoginAdmin": this.$store.state.is_admin
      });
      console.log("model: ", model)
      const formData = new FormData();
      formData.append("FilesPhoto", this.photo);
      formData.append("ModelStr", JSON.stringify(model));
      axios({
          method: "POST",
          url: `${this.apiURL}/Resources/PersonsTeachers/UpdateByTeachersByCandidateAccount`,
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': 'Bearer ' + this.$store.state.authToken
          }
        })
        .then(response => {

          if (response.data != null && response.data.return) {

            this.formTeacher.extension_Phone = this.iti.selectedCountryData.dialCode;


            this.infoTeacher = this.getFormatData(this.formTeacher);

            //Actualizar datos de store user teacher


            let jsonUser = {
              email: this.User.email,
              firstName: this.User.firstName,
              id: this.User.id,
              lastName: this.User.lastName,
              personTeacherId: this.User.personTeacherId,
              personsTypeId: this.User.personsTypeId,
              photo: this.User.photo,
              strFullName: this.User.strFullName,
              timeZoneName: this.User.timeZoneName,
              totalClassRequest: this.User.totalClassRequest,
              totalDetail:this.User.totalDetail,
            }
            jsonUser.firstName = this.formTeacher.firstName
            jsonUser.lastName = this.formTeacher.lastName
            jsonUser.strFullName = `${this.formTeacher.firstName} ${this.formTeacher.lastName}`
            jsonUser.email = this.formTeacher.email
            if (response.data.entity != null) {
              jsonUser.photo = response.data.entity.photo;
            }

            this.$store.dispatch("updateUserAction", jsonUser);
            //Fin

            this.messageRegisterTeacher = this.$t('mjesRegistro.registry-updated-successfully')
            this.$bvToast.show("toast-register-check-postulant");
            this.accountStatus = true;
            this.toggleEditAccount(true)
            this.changeActivityTab(0);
            this.flajImg = this.iti.selectedCountryData.iso2;
          } else {
            this.messageRegisterTeacher = this.$t('mjesRegistro.mjeActualizacionError');
            this.$bvToast.show("toast-register-error-postulant");
          }
          this.isLoading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.messageRegisterTeacher = this.$t('mjesRegistro.mjeActualizacionError');
          this.$bvToast.show("toast-register-error-postulant");
          this.isLoading = false;
        });

    },

    filesSelectedDegrees(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
      this.fileRecordsForUploadDegrees = this.fileRecordsForUploadDegrees.concat(validFileRecords);
    },

    onBeforeDeleteDegrees(fileRecord) {
      var i = this.fileRecordsForUploadDegrees.indexOf(fileRecord);
      if (i !== -1) {

        this.fileRecordsForUploadDegrees.splice(i, 1);
        var k = this.fileDegrees.indexOf(fileRecord);
        if (k !== -1) this.fileDegrees.splice(k, 1);
      } else {
        if (confirm('Are you sure you want to delete?')) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
        }
      }
    },

    fileDeletedDegrees(fileRecord) {
      var i = this.fileRecordsForUploadDegrees.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUploadDegrees.splice(i, 1);
      } else {
        this.deleteUploadedFileCV(fileRecord);
      }
    },
    deleteUploadedFileDegrees: function(fileRecord) {

      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
    },


    filesSelectedCerti(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
      this.fileRecordsForUploadCerti = this.fileRecordsForUploadCerti.concat(validFileRecords);
    },

    onBeforeDeleteCerti(fileRecord) {
      var i = this.fileRecordsForUploadCerti.indexOf(fileRecord);
      if (i !== -1) {

        this.fileRecordsForUploadCerti.splice(i, 1);
        var k = this.fileCerti.indexOf(fileRecord);
        if (k !== -1) this.fileCerti.splice(k, 1);
      } else {
        if (confirm('Are you sure you want to delete?')) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
        }
      }
    },

    fileDeletedCerti(fileRecord) {
      var i = this.fileRecordsForUploadCerti.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUploadCerti.splice(i, 1);
      } else {
        this.deleteUploadedFileCV(fileRecord);
      }
    },
    deleteUploadedFileCerti: function(fileRecord) {

      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
    },
    filesSelectedCV(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
      this.fileRecordsForUploadCV = this.fileRecordsForUploadCV.concat(validFileRecords);
      this.numFileCV=this.fileRecordsForUploadCV.length;
    },

    onBeforeDeleteCV(fileRecord) {
      var i = this.fileRecordsForUploadCV.indexOf(fileRecord);
      if (i !== -1) {

        this.fileRecordsForUploadCV.splice(i, 1);
        this.numFileCV=this.fileRecordsForUploadCV.length;
        var k = this.fileCV.indexOf(fileRecord);
        if (k !== -1) this.fileCV.splice(k, 1);
      } else {
        if (confirm('Are you sure you want to delete?')) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
        }
      }
    },

    fileDeletedCV(fileRecord) {
      var i = this.fileRecordsForUploadCV.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUploadCV.splice(i, 1);
      } else {
        this.deleteUploadedFileCV(fileRecord);
      }
    },
    deleteUploadedFileCV: function(fileRecord) {

      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
    },
  },
}
</script>

<style lang="scss">
.iti__flag {
  background-image: url("/images/flags.png");
}
.tabs.sm .nav-tabs {
    max-width: 900px;
    flex-wrap: initial;
}
.iti.iti--allow-dropdown input.form-control{
    width: 100% !important;
}
.iti.iti--allow-dropdown .iti__flag-container .iti__selected-flag{
    width: 100%;
}
.custom-checkbox .custom-control-label::before{
    top: 0;
}
.custom-checkbox .custom-control-label::after{
    top: 0;
}
.account-data .form-group .iti{
    width: 39%;
    max-width: 150px;
}

.file-preview-wrapper .file-preview .file-ext, 
.file-preview-wrapper .file-preview .image-dimension, 
.file-preview-wrapper .file-preview .file-size{
  display: none;
}

.file-preview-wrapper .file-preview .file-name .file-name-text{
  color: #508adf !important;
  font-size: 13px;
}
.file-preview-wrapper .file-preview  .file-delete svg {
    fill: #d1263a !important;
}

.theme-list .vue-file-agent .file-preview-wrapper .file-preview{
  height: 40px
}


.theme-list .vue-file-agent .file-preview-wrapper .file-preview .file-icon svg {
    height: 40px;
    width: 40px;
    margin-top: 1px;
}

</style>